import { render, staticRenderFns } from "./TalentTimeLine.vue?vue&type=template&id=20952288"
import script from "./TalentTimeLine.vue?vue&type=script&lang=js"
export * from "./TalentTimeLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports